import { render } from "./TicketCardList.vue?vue&type=template&id=4b352e91"
import script from "./TicketCardList.vue?vue&type=script&lang=js"
export * from "./TicketCardList.vue?vue&type=script&lang=js"

import exportComponent from "/codebuild/output/src739691156/src/fellow/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__